export const CLASS_ROOT = "carousel";

export const CLASS_VIEWPORT_WRAPPER = `${CLASS_ROOT}__viewport-wrapper`;
export const CLASS_VIEWPORT = `${CLASS_ROOT}__viewport`;
export const CLASS_TRACK = `${CLASS_ROOT}__track`;
export const CLASS_SLIDE = `${CLASS_ROOT}__slide`;
export const CLASS_SLIDE_NEXT = `${CLASS_ROOT}__slide-next`;
export const CLASS_SLIDE_PREV = `${CLASS_ROOT}__slide-prev`;
export const CLASS_PREV = `${CLASS_ROOT}__prev`;
export const CLASS_NEXT = `${CLASS_ROOT}__next`;
export const CLASS_DOTS = `${CLASS_ROOT}__pagination`;
export const CLASS_NAVIGATION = `${CLASS_ROOT}__navigation`;
export const CLASS_CONTROLS = `${CLASS_ROOT}__controls`;
export const CLASS_DOT = `${CLASS_ROOT}__pagination-item`;
export const CLASS_SCROLLBAR = `${CLASS_ROOT}__scrollbar`;
export const CLASS_SCROLLBAR_HORIZONTAL = `${CLASS_ROOT}__scrollbar-horizontal`;
export const CLASS_SCROLLBAR_DRAG = `${CLASS_ROOT}__scrollbar-drag`;
export const CLASS_ACTIVE = "is-active";
export const CLASS_SCROLLBAR_VARIANT = `${CLASS_ROOT}--scrollbar`;
export const CLASS_BLEED_RIGHT = `${CLASS_ROOT}--bleed-right`;
export const CLASS_BLEED_RIGHT_NO_LEFT = `${CLASS_ROOT}--bleed-right-no-left`;

export const SELECTOR_VIEWPORT = `.${CLASS_VIEWPORT}`;
export const SELECTOR_TRACK = `.${CLASS_TRACK}`;
export const SELECTOR_PREV = `.${CLASS_PREV}`;
export const SELECTOR_NEXT = `.${CLASS_NEXT}`;
export const SELECTOR_DOTS = `.${CLASS_DOTS}`;
export const SELECTOR_SCROLLBAR = `.${CLASS_SCROLLBAR}`;
export const SELECTOR_ACTIVE = `.${CLASS_ACTIVE}`;
